import React from 'react'
import { Line } from 'react-chartjs-2'
import { months } from '../../shared/data'

export default function MultipleLineChart({ currentYear, previousYear }) {
  const MultipleLinedata = (canvas) => {
    const ctx = canvas.getContext('2d')
    const gradient1 = ctx.createLinearGradient(55, 81, 255, 1)
    gradient1.addColorStop(0, ' blue')
    gradient1.addColorStop(1, '#F5F8FF')

    const data1 = {
      label: 'Previous Year',
      data: previousYear,

      pointRadius: 0,
      borderColor: '#3751FF',
      tension: 0.4,
      fill: false,
      backgroundColor: gradient1,
    }

    const data2 = {
      label: 'Current Year',
      data: currentYear,

      pointRadius: 0,
      borderColor: '#05CFD3',
      tension: 0.4,
      fill: false,
      backgroundColor: 'rgba(245, 248, 255, 1)',
    }
    return {
      labels: months,

      datasets: [data1, data2],
    }
  }
  return (
    <div>
      <Line data={MultipleLinedata} />
    </div>
  )
}
